import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { notifInitialization } from "./services/definedMethod";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { configureConsole } from "./utils/disableConsole";
import "./utils/devtoolsDetector";
import appConfig from "./config/appConfig";

if (appConfig.isProduction) {
  disableReactDevTools();
  configureConsole();
}


const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

root.render(<App />);

// Initialize notiflix popup
notifInitialization();
